import { TimelineSpan } from '../domain/TimelineSpan'

const spanContains = (a: TimelineSpan, b: TimelineSpan): boolean => {
    return a.cs <= b.cs && a.cs + a.wt >= b.cs + b.wt
}

const isRecursiveCall = (previousSpan: TimelineSpan | null, span: TimelineSpan): boolean => {
    if (!previousSpan) {
        return false
    }

    return spanContains(previousSpan, span)
}

const getSpanWt = (span: TimelineSpan) => {
    return span.annotations && 'repeat_wt' in span.annotations ? parseInt('' + span.annotations.repeat_wt, 10) : span.wt
}

const getSpanCount = (span: TimelineSpan) => {
    return span.annotations && 'repeat_count' in span.annotations ? parseInt('' + span.annotations.repeat_count, 10) : 1
}

export const groupSpans = (spanData: TimelineSpan[], maxWt: number): TimelineSpan[] => {
    const groupedSpans = groupBy(spanData, 'name')

    return groupedSpans.map(spans => {
        let count = 0
        let wallTime = 0
        let exclusiveWallTime = 0

        let previousSpan: TimelineSpan | null = null

        for (const span of spans) {
            if (!isRecursiveCall(previousSpan, span)) {
                wallTime += getSpanWt(span)
            }

            count += getSpanCount(span)
            exclusiveWallTime += span.excl_wt

            previousSpan = span
        }

        const createdSpan: TimelineSpan = {
            id: spans[0].id,
            name: spans[0].name,
            cat: spans[0].cat,
            type: spans[0].type,
            cs: spans[0].cs,
            fn: spans[0].annotations && spans[0].annotations.fn ? '' + spans[0].annotations.fn : null,
            ct: count,
            wt: wallTime,
            excl_wt: exclusiveWallTime,
            custom_type: spans[0].cat === 'custom' && spans[0].annotations?.custom_type ? '' + spans[0].annotations.custom_type : undefined,
        }
        createdSpan.perc_wt = createdSpan.wt / maxWt
        createdSpan.perc_excl_wt = createdSpan.excl_wt / maxWt
        return createdSpan
    })
}

const groupBy = (spans: TimelineSpan[], key: string): TimelineSpan[][] =>
    Object.values(
        spans.reduce(
            (result, span) => ({
                ...result,
                [span[key]]: [...(result[span[key]] || []), span],
            }),
            {},
        ),
    )
